module.exports = __webpack_public_path__ + "img/complete_24_checked.4fcc432a.svg";